// extracted by mini-css-extract-plugin
export var actionText = "_o9-4";
export var container = "_o9-0";
export var leftSection = "_o9-1";
export var rightSection = "_o9-2";
export var settingsButton = "_o9-6";
export var settingsIcon = "_o9-7";
export var shortcut = "_o9-5";
export var shortcutGroup = "_o9-3";